import _ from 'lodash';
import { getUpdatedElementPosition, getUpdatedElementPositionByDelta, getMaxDeltaY} from '../helpers/elementPositionHelpers';
import { getUpdatedElementSizeByDirection, getUpdatedElementSize } from '../helpers/elementSizeHelpers';
import { getElementDefinitionProps } from 'crazyEditor/core/elements/utils/elementDefinitionUtils';
import { PAGE_ELEMENT_ID } from 'crazyEditor/core/elements/utils/elementStaticUtils';
import { getViewState } from '../helpers/elementViewHelpers';
import * as elementActionTypes from '../actions/elementLayoutActions';
import update from 'react-addons-update';
import { getElementList } from '../helpers/elementListHelpers';

export default function reducer(state = [], action = {}) {
  let elementLayout;
  let viewState;
  let elementsToUpdate = {};
  let overflowingElementId;
  let element;
  let draggableDirections;
  let forceDraggableDirection;
  let elementId;
  let elements;
  let elementList;

  switch (action.type) {
    case elementActionTypes.UPDATE_ELEMENT_POSITION:
      viewState = getViewState(action.viewMode, state);
      elementId = action.ids[0];
      elementLayout = getUpdatedElementPosition(viewState, state, action, elementId);
      elementList = getElementList(elementId);

      return update(state, {
        [viewState]: {
          [elementList]: {
            [elementId]: {
              layout: {
                x: {
                  $set: elementLayout.x
                },
                y: {
                  $set: elementLayout.y
                }
              }
            }
          }
        }
      });
    case elementActionTypes.UPDATE_ELEMENT_POSITION_BY_DELTA:
    case elementActionTypes.DRAG_COMPLETE_AND_UPDATE_ELEMENTS_POSITION:
      viewState = getViewState(action.viewMode, state);
      elementsToUpdate = {};
      elementId = action.ids[0];
      elementList = getElementList(elementId);

      elements = [];
      action.ids.forEach(id => {
        element = state[viewState].elements[id];
        if (element) {
          elements.push(element);
        }
      });
      draggableDirections = {x: true, y: true};
      elements.forEach((element) => {
        const elementDraggableDirections = getElementDefinitionProps(element).draggable;
        draggableDirections.x &= elementDraggableDirections.x;
        draggableDirections.y &= elementDraggableDirections.y;
      });

      const maxDeltaY = getMaxDeltaY(viewState, state, elements);
      elements.forEach((element) => {
        if (element && !element.locked) {
          elementLayout = getUpdatedElementPositionByDelta(viewState, state, action, element, draggableDirections, maxDeltaY);
          if (elementLayout.overflowing) {
            overflowingElementId = elementId;
          }
          if (!forceDraggableDirection && draggableDirections.length === 1) {
            forceDraggableDirection = draggableDirections[0];
          }
          elementsToUpdate[element.id] = {
            layout: {
              x: {
                $set: elementLayout.x
              },
              y: {
                $set: elementLayout.y
              }
            }
          };
        }
      });
      if (!_.isEmpty(elementsToUpdate) && (action.deltaX !== 0 || action.deltaY !== 0)) {
        _.forEach(elementsToUpdate, (elementToUpdate, index) => {
          if (overflowingElementId) {
            if (parseInt(index, 10) !== overflowingElementId) {
              delete(elementToUpdate.layout.y);
            }
          }
        });
        return update(state, {
          [viewState]: {
            [elementList]: elementsToUpdate
          }
        });
      }
      return state;
    case elementActionTypes.DRAG_COMPLETE_AND_UPDATE_ELEMENTS_SIZE:
    case elementActionTypes.UPDATE_ELEMENT_SIZE_BY_DIRECTION:
      viewState = getViewState(action.viewMode, state);
      elementsToUpdate = {};
      elementId = action.ids[0];
      elementList = getElementList(elementId);

      _.forEach(action.ids, (id) => {
        elementId = id;
        elementLayout = getUpdatedElementSizeByDirection(viewState, state, action, elementId);
        if (elementLayout.overflowing) {
          overflowingElementId = elementId;
        }
        elementsToUpdate[elementId] = {
          layout: {
            x: {
              $set: elementLayout.x
            },
            y: {
              $set: elementLayout.y
            },
            width: {
              $set: elementLayout.width
            },
            height: {
              $set: elementLayout.height
            }
          }
        };
      });
      if (!_.isEmpty(elementsToUpdate)) {
        if (overflowingElementId) {
          _.forEach(elementsToUpdate, (elementToUpdate, index) => {
            if (parseInt(index, 10) !== overflowingElementId) {
              delete(elementToUpdate.layout.y);
            }
          });
        }
        return update(state, {
          [viewState]: {
            [elementList]: elementsToUpdate
          }
        });
      }
      return state;
    case elementActionTypes.UPDATE_ELEMENT_SIZE:
      viewState = getViewState(action.viewMode, state);
      elementId = action.ids[0];
      elementList = getElementList(elementId);
      elementLayout = getUpdatedElementSize(viewState, state, action, elementId);

      return update(state, {
        [viewState]: {
          [elementList]: {
            [elementId]: {
              layout: {
                width: {
                  $set: elementLayout.width
                },
                height: {
                  $set: elementLayout.height
                }
              }
            }
          }
        }
      });
    case elementActionTypes.UPDATE_MEASURED_HEIGHTS:
      viewState = 'desktop'; // currently supported only by desktop
      elements = state[viewState].elements;
      elementsToUpdate = {};
      _.forEach(action.measuredSizes, (measuredSize) => {
        elementId = measuredSize.id;
        element = elements[elementId];
        if (element && measuredSize.layout.height !== element.layout.height) {
          elementsToUpdate[elementId] = {
            layout: {
              $merge: measuredSize.layout,
            }
          };
        }
      });
      if (!_.isEmpty(elementsToUpdate)) {
        return update(state, {
          [viewState]: {
            elements: elementsToUpdate
          },
          measuredSizes: {
            $set: action.measuredSizes // we store the measured sizes to perform updates only if they were changed.
          }
        });
      }
      return state;
    default:
      return state;
  }
}
